import { ReactElement } from 'react';
import { useCartContext } from 'CartContext';
import {
  useIsMarketplace,
  useIsMarketplaceDomain,
  useMarketplaceDomain,
} from 'hooks/useMarketplace';
import MarketplaceFooter from 'components/footer-marketplace/MarketplaceFooter';
import './Footer.scss';

export default function Footer(): ReactElement {
  const urlParams = window.location.search;
  const isParamOpenSKU = urlParams.match(/\b(\w*openSku\w*)\b/g);
  const foundParam = isParamOpenSKU
    ?.filter(param => param.toLowerCase().includes('opensku'))
    .toString();
  const isMarketplace = useIsMarketplace();
  const marketPlaceDomain = useMarketplaceDomain();
  const isMarketplaceDomain = useIsMarketplaceDomain();

  const { hideNav } = useCartContext();

  if (
    (isMarketplace || isMarketplaceDomain) &&
    !hideNav &&
    !foundParam &&
    marketPlaceDomain === 'advancedmedicine'
  ) {
    return <MarketplaceFooter />;
  }

  return <></>;
}
